var React = require('react');

function PlaceRedInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"Path_234","data-name":"Path 234","d":"M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z","fill":"#f74e4f","key":0}),React.createElement("g",{"id":"Group_631","data-name":"Group 631","transform":"translate(8.75 7.502)","key":1},React.createElement("path",{"id":"Path_256","data-name":"Path 256","d":"M381.218,360.437a6.252,6.252,0,0,0-6.25,6.24,5.778,5.778,0,0,0,.031.606c.424,4.42,5.329,8.88,5.541,9.072l.677.606.678-.606c.222-.2,5.149-4.682,5.542-9.113a5.372,5.372,0,0,0,.03-.566A6.252,6.252,0,0,0,381.218,360.437Zm0,8.262a2.022,2.022,0,1,1,2.022-2.023A2.016,2.016,0,0,1,381.218,368.7Z","transform":"translate(-374.968 -360.437)","fill":"#fff"}))]);
}

PlaceRedInline.defaultProps = {"id":"PlaceRed_Locked_Icon","data-name":"PlaceRed Locked Icon","width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = PlaceRedInline;

PlaceRedInline.default = PlaceRedInline;
